module.exports = __webpack_public_path__ + "img/heart.4dfae4c9.svg";